
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $800sp = parcelRequire("800sp");
class $98d8933019691929$export$2e2bcd8739ae039 extends (0, $800sp.LitElement) {
    static get properties() {
        return {
            scene: {
                type: Object
            },
            heading: {
                type: Number
            }
        };
    }
    static get styles() {
        return (0, $800sp.css)`
      :host {
        --cesium-compass-bar-tick-color: #000;
        --cesium-compass-bar-intercardinal-width: 100px;
      }
      :host * {
        box-sizing: content-box;
      }
      .container {
        display: flex;
        justify-content: center;
        height: 100%;
        overflow: hidden;
      }
      .compass-bar {
        display: flex;
        align-items: flex-end;
      }
      .compass-bar > div {
        width: var(--cesium-compass-bar-intercardinal-width);
        text-align: center;
      }
      .label {
        padding: 4px;
        color: var(--cesium-compass-bar-tick-color);
      }
      .ticks {
        display: flex;
        justify-content: space-around;
      }
      .ticks > div {
        width: 1px;
        height: 6px;
        background-color: var(--cesium-compass-bar-tick-color);
      }
      .ticks > div:nth-child(4) {
        height: 10px;
      }
      .center-tick {
        margin: auto;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: var(--cesium-compass-bar-tick-color);
      }
    `;
    }
    constructor(){
        super();
        /**
     * @type {import('cesium').Scene}
     */ this.scene;
        /**
     * @type {number}
     */ this.intercardinalWidth;
        /**
     * @type {import('cesium').Event.RemoveCallback}
     */ this.unlistenFromPostRender = null;
    }
    updated() {
        if (this.scene && !this.unlistenFromPostRender) {
            this.unlistenFromPostRender = this.scene.postRender.addEventListener(()=>{
                this.heading = this.scene.camera.heading;
            });
            // FIXME: probably not the best place to compute this
            this.intercardinalWidth = parseInt(getComputedStyle(this).getPropertyValue('--cesium-compass-bar-intercardinal-width'));
        }
    }
    getTransform(index) {
        const width = this.intercardinalWidth;
        let translate = -width / 2;
        const visibleIndex = -this.heading / (Math.PI / 4) + 4;
        const distance = visibleIndex - index;
        if (distance < -4) translate += 8 * width;
        if (distance > 4) translate -= 8 * width;
        return `transform: translate(${visibleIndex * width + translate}px)`;
    }
    render() {
        const ticks = (0, $800sp.html)`
      <div class="ticks">
        ${Array(7).fill().map(()=>(0, $800sp.html)`<div part="tick"></div>`)}
      </div>
    `;
        return (0, $800sp.html)`
      <div class="container">
        <div class="compass-bar">
          <div style=${this.getTransform(4)}>
            <div class="label" part="label major">N</div>
            ${ticks}
          </div>
          <div style=${this.getTransform(3)}>
            <div class="label" part="label minor">NE</div>
            ${ticks}
          </div>
          <div style=${this.getTransform(2)}>
            <div class="label" part="label major">E</div>
            ${ticks}
          </div>
          <div style=${this.getTransform(1)}>
            <div class="label" part="label minor">SE</div>
            ${ticks}
          </div>
          <div style=${this.getTransform(0)}>
            <div class="label" part="label major">S</div>
            ${ticks}
          </div>
          <div style=${this.getTransform(-1)}>
            <div class="label" part="label minor">SW</div>
            ${ticks}
          </div>
          <div style=${this.getTransform(-2)}>
            <div class="label" part="label major">W</div>
            ${ticks}
          </div>
          <div style=${this.getTransform(-3)}>
            <div class="label" part="label minor">NW</div>
            ${ticks}
          </div>
        </div>
      </div>
      <div class="center-tick" part="center-tick"></div>
    `;
    }
}
customElements.define("cesium-compass-bar", $98d8933019691929$export$2e2bcd8739ae039);


//# sourceMappingURL=cesium-compass-bar.552ea5f1.js.map
